import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  // --------------EasyInest-----------------
  REQAnalyticList,
  RESAnalyticList,
  FailAnalyticList,
  // --------------UntHld-----------------
  REQAnalyticUntHldList,
  RESAnalyticUntHldList,
  FailAnalyticUntHldList,
  // --------------PVD-----------------
  REQAnalyticPVDList,
  RESAnalyticPVDList,
  FailAnalyticPVDList,
  // --------------PVD Excel Download-----------------
  REQAnalyticPVDExcelDownload,
  RESAnalyticPVDExcelDownload,
  FailAnalyticPVDExcelDownload,
  PROGRESSAnalyticPVDExcelDownload
} from "./actions";
import moment from "moment";
import * as actions from "../../Authentication/redux/actions";

function* fetchAnalyticListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUserAccount`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticList(response));
    } else {
      yield put(RESAnalyticList());
    }
  } catch (error) {

    yield put(FailAnalyticList());
  }
}

function* fetchAnalyticUntHldListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUnitHolder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticUntHldList(response));
    } else {
      yield put(RESAnalyticUntHldList());
    }
  } catch (error) {

    yield put(FailAnalyticUntHldList());
  }
}

function* fetchAnalyticPVDListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, page = 1, per_page = 50, sort_by = 'pvd_regis_date', sort_order = 'asc', filterType } = payload;

    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";

    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/pvdconversion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD,
          page,
          per_page,
          sort_by,
          sort_order,
          filterType
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();
    if (process.env.NODE_ENV !== "production") {
      console.log('🔵 Full API Response:', response);
    }

    // Map API response to expected shape for the table
    if (response && response.data && Array.isArray(response.data)) {
      // Map backend summary keys to frontend expected keys
      const rawSummary = response.summary || {};
      const summary = {
        totalUsers: rawSummary.totalUsers ?? rawSummary.total_users ?? rawSummary.totalCount ?? 0,
        mfUnitholder: rawSummary.mfUnitholder ?? rawSummary.mf_unitholder ?? rawSummary.mfUnitholderCount ?? 0,
        pvdUnitholder: rawSummary.pvdUnitholder ?? rawSummary.pvd_unitholder ?? rawSummary.pvdUnitholderCount ?? 0,
        noUnitholder:
          rawSummary.noUnitholder ?? rawSummary.no_unitholder ??
          (rawSummary.totalCount !== undefined && rawSummary.mfUnitholderCount !== undefined && rawSummary.pvdUnitholderCount !== undefined
            ? rawSummary.totalCount - rawSummary.mfUnitholderCount - rawSummary.pvdUnitholderCount
            : 0)
      };

      console.log('✅ Mapped Summary:', summary);
      console.log('✅ Results Count:', response.data.length);

      yield put(RESAnalyticPVDList({
        results: response.data,
        pagination: response.pagination,
        summary,
        applied_filters: response.applied_filters,
        message: response.message,
        timestamp: response.timestamp
      }));
    } else {
      console.log('❌ Response structure mismatch:', response);
      yield put(RESAnalyticPVDList({ results: [], pagination: {}, summary: { totalUsers: 0, mfUnitholder: 0, pvdUnitholder: 0, noUnitholder: 0 } }));
    }
  } catch (error) {
    yield put(FailAnalyticPVDList());
  }
}

function* fetchAnalyticPVDExcelDownloadWorker({ payload }) {
  const CHUNK_SIZE = 10000;
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, sort_by = 'pvd_regis_date', sort_order = 'asc', filterType } = payload;

    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";

    const url = `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/pvdconversion`;
    const headers = {
      "Content-Type": "application/json",
      userid: tGUID,
      'x-id-token': "Bearer " + accessToken
    };
    const buildBody = (page) => JSON.stringify({
      startDate: tStartD1,
      endDate: tEndD1,
      allDate: bAllD,
      page,
      per_page: CHUNK_SIZE,
      sort_by,
      sort_order,
      filterType
    });

    // ── Page 1: get first chunk + learn total_pages ──
    const firstRequest = yield fetch(url, { method: "POST", headers, body: buildBody(1) });
    if (firstRequest.status === 401) {
      yield put(actions.autoSignOut());
      yield put(FailAnalyticPVDExcelDownload());
      return;
    }
    if (!firstRequest.ok) {
      yield put(FailAnalyticPVDExcelDownload());
      return;
    }
    const firstResponse = yield firstRequest.json();
    const totalPages = firstResponse?.pagination?.total_pages || 1;
    let allData = Array.isArray(firstResponse?.data)
      ? firstResponse.data
      : Array.isArray(firstResponse) ? firstResponse : [];
    yield put(PROGRESSAnalyticPVDExcelDownload({ current: 1, total: totalPages }));

    // ── Pages 2..N: fetch remaining chunks sequentially ──
    for (let page = 2; page <= totalPages; page++) {
      const req = yield fetch(url, { method: "POST", headers, body: buildBody(page) });
      if (req.status === 401) {
        yield put(actions.autoSignOut());
        yield put(FailAnalyticPVDExcelDownload());
        return;
      }
      if (!req.ok) {
        yield put(FailAnalyticPVDExcelDownload());
        return;
      }
      const res = yield req.json();
      const chunk = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      Array.prototype.push.apply(allData, chunk);
      yield put(PROGRESSAnalyticPVDExcelDownload({ current: page, total: totalPages }));
    }

    yield put(RESAnalyticPVDExcelDownload(allData));
  } catch (error) {
    console.error('❌ PVD Excel Download Error:', error);
    yield put(FailAnalyticPVDExcelDownload());
  }
}

export function* analyticListSaga() {
  yield all([
    takeLatest(REQAnalyticList, fetchAnalyticListWorker),
    takeLatest(REQAnalyticUntHldList, fetchAnalyticUntHldListWorker),
    takeLatest(REQAnalyticPVDList, fetchAnalyticPVDListWorker),
    takeLatest(REQAnalyticPVDExcelDownload, fetchAnalyticPVDExcelDownloadWorker)
  ]);
}